import React from 'react';
import { FaCaretRight } from 'react-icons/fa';
import { TbPercentage } from 'react-icons/tb';
import { RxCross2 } from 'react-icons/rx';
import { Minus, Plus } from 'lucide-react';
import config from '../../../../../config/environment';
import { Link } from 'react-router-dom';
import Namsteji_Manikchand_Icon from '../../../../../assets/images/Namsteji_Manikchand_Icon.svg';
import CouponPage from '../../Cart/Components/CouponPage';
import ProductAddToCartMobilePage from './ProductAddToCartMobilePage';

const SERVER_URL = config.SERVER_URL;

const ProductAddToCart: React.FC<any> = ({
  isCartOpen,
  setIsCartOpen,
  cartItems,
  cartDataArr,
  cartItemPlusMinus,
  couponObj,
}) => {
  return (
    <>
      {isCartOpen && <div onClick={() => setIsCartOpen(false)} className='fixed inset-0 bg-black bg-opacity-40 z-40' />}

      {/* Mobile View  */}
      <ProductAddToCartMobilePage
        cartDataArr={cartDataArr}
        isCartOpen={isCartOpen}
        cartItemPlusMinus={cartItemPlusMinus}
        setIsCartOpen={setIsCartOpen}
        cartItems={cartItems}
        couponObj={couponObj}
      />

      {/*  MD LG View  */}
      <div className='hidden sm:hidden md:hidden lg:flex'>
        <div
          className={`fixed top-0 right-0 h-full bg-white shadow-lg z-50 transform transition-transform duration-300 flex flex-col
                    ${isCartOpen ? 'translate-x-0' : 'translate-x-full'}
                    w-full md:w-[80%] lg:w-[500px] xl:w-[600px]`}
        >
          <div
            className='flex justify-between items-center p-4 border-b font-rubik'
            style={{ borderBottomColor: '#E2C06C' }}
          >
            <h2 className='text-2xl font-semibold text-[#4A2D1A] font-rubik'>Your Cart</h2>
            <button onClick={() => setIsCartOpen(false)} className='text-2xl text-[#4A2D1A]'>
              <RxCross2 />{' '}
            </button>
          </div>

          <div className='flex-1 overflow-y-auto p-4 flex flex-col gap-4'>
            {cartItems.map((item: any, index: any) => {
              const isDisabled = !item.tax_amount || item.tax_amount <= 0;

              return (
                <div
                  key={`${item.item_code}-${index}`}
                  className={`flex flex-col md:flex-row items-start md:items-center gap-4 p-3 rounded-lg border border-gray-200 ${isDisabled ? 'opacity-80 pointer-events-none' : ''}`}
                >
                  <img
                    src={
                      item.web_item_name?.thumbnail
                        ? SERVER_URL + item.web_item_name?.thumbnail
                        : Namsteji_Manikchand_Icon
                    }
                    alt=''
                    className='w-[100px] h-[100px] object-cover rounded'
                  />
                  <div className='flex-1 flex flex-col justify-between w-full'>
                    <h3 className='text-lg md:text-xl font-poppins'>{item.web_item_name?.web_item_name}</h3>
                    <p className='text-sm md:text-base text-[#9E9E9E] font-poppins'>
                      Pack Of&nbsp;{item.uom_conversion?.conversion_factor}
                    </p>

                    {/* Plus-Minus Button Section */}
                    <div
                      className={`flex items-center gap-2 border border-[#C12E2A] rounded-lg px-2 py-1 mt-2 w-max
                                            ${isDisabled ? 'pointer-events-none opacity-80 cursor-not-allowed' : ''}`}
                    >
                      <button onClick={() => cartItemPlusMinus(item.qty, item.item_code, 'minus')}>
                        <Minus className='text-red-700' size={16} />
                      </button>
                      <span className='font-poppins'>{item.qty}</span>
                      <button onClick={() => cartItemPlusMinus(item.qty, item.item_code, 'plus')}>
                        <Plus className='text-red-700' size={16} />
                      </button>
                    </div>
                  </div>

                  <div className='flex flex-col items-end mt-2 md:mt-0'>
                    <p className='text-lg md:text-xl font-semibold font-poppins'>
                      ₹{item.tax_amount ? item.tax_amount.toFixed(2) : '0.00'}
                    </p>
                  </div>
                </div>
              );
            })}
            {couponObj.listOfCoupen.current && couponObj.listOfCoupen.current.length > 0 && (
              <div
                onClick={() => couponObj.setShowCoupenModalMobile(true)}
                className='flex items-center justify-center gap-2 py-3 rounded-xl shadow-md border cursor-pointer'
              >
                <div className='w-6 h-6 flex items-center justify-center rounded-full bg-[#552B18]'>
                  <TbPercentage className='w-4 h-4 text-white' />
                </div>
                <span className='font-medium text-[#552B18] font-poppins'>See all offers</span>
                <FaCaretRight className='w-4 h-4 text-[#4A2D1A]' />
              </div>
            )}

            <div className='p-4 bg-white rounded-lg shadow-md gap-2 mt-3'>
              <h2 className='text-lg font-semibold mb-4 font-poppins'>Cart Total</h2>
              <div className='text-sm sm:text-sm md:text-base text-[#9E9E9E]'>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>Subtotal</span>
                  <span className='font-poppins'>₹ {cartDataArr?.net_total?.toFixed(2)}</span>
                </div>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>
                    Discount{' '}
                    {cartDataArr?.additional_discount_percentage
                      ? '(' + cartDataArr?.additional_discount_percentage + ') % OFF'
                      : ''}
                  </span>
                  <span className='font-poppins'>
                    ₹ {cartDataArr?.discount_amount ? cartDataArr.discount_amount.toFixed(2) : '0.00'}
                  </span>
                </div>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>Effective subtotal</span>
                  <span className='font-poppins'>
                    ₹ {cartDataArr?.discount_amount ? cartDataArr.discount_amount.toFixed(2) : '0.00'}
                  </span>
                </div>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>GST</span>
                  <span className='font-poppins'>₹ {cartDataArr?.tax_amount?.toFixed(2)}</span>
                </div>
                <div className='flex justify-between mb-2'>
                  <span className='font-poppins'>Shipping</span>
                  <span className='text-green-600 font-poppins'>Free</span>
                </div>
                <hr className='my-2 border-gray-300' />
                <div className='flex justify-between text-base font-semibold mb-4 font-poppins text-black'>
                  <span className='font-poppins'>Grand Total</span>
                  <span className='font-poppins'>
                    ₹ {cartDataArr?.grand_total ? cartDataArr?.grand_total?.toFixed(2) : '0.00'}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className='p-4 border-t bg-[#F5E6D3] flex justify-between items-center'>
            <div>
              <p className='text-sm font-medium font-poppins'>Grand Total ({cartItems.length} items)</p>
              <p className='text-lg font-semibold font-poppins'>₹{cartDataArr.grand_total}</p>
              {/* <p className="text-sm line-through text-[#9E9E9E]">₹1300</p> */}
            </div>
            <button className='bg-[#C12E2A] text-white py-2 px-4 rounded hover:bg-red-700 transition font-poppins'>
              <Link to='/product/billing-info'>Proceed to Checkout</Link>
            </button>
          </div>

          {couponObj.showCoupenModalMobile && (
            <div tabIndex={-1} className='fixed top-0 left-0 right-0 z-50 w-full overflow-x- overflow-y-auto '>
              <div className='relative bg-white rounded-lg shadow-sm dark:bg-gray-700 min-h-[100vh]'>
                <div className='flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200'>
                  <div></div>
                  <div className='text-xl font-bold font-rubik text-[#552B18]'>Coupon Code</div>
                  <button
                    type='button'
                    className='bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg'
                    onClick={() => couponObj.setShowCoupenModalMobile(false)}
                  >
                    <RxCross2 className='text-xl text-[#552B18]' />
                  </button>
                </div>
                <CouponPage
                  inputCode={couponObj.inputCode}
                  handleApply={couponObj.handleApply}
                  listOfCoupen={couponObj.listOfCoupen}
                  appliedCouponName={couponObj.appliedCouponName.current}
                  handleRemoveCoupon={couponObj.handleRemoveCoupon}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductAddToCart;
